type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};

/** Bare exclamation glyph, no surrounding circle — sits inside a filled status
 *  badge (see the notification toast). For the outlined circle + bang, use
 *  CircleExclammationIcon. */
const ExclamationIcon = (props: Props) => {
  const { width = '12', height = '12', strokeColor = 'currentColor' } = props;
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none">
      <path
        d="M6 2.75V7"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
      <path
        d="M6 9.25H6.005"
        stroke={strokeColor}
        strokeWidth="1.75"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default ExclamationIcon;
